import styled from "styled-components";

export const CreateContainer = styled.div`
  width: 100%;
  height: 100%;
  padding: 20px;
  overflow-y: auto;
  display: flex;
  gap: 20px;
`

export const Container = styled.div`
  flex: 1;
  max-width: 600px;
`

export const TitleBig = styled.div`
  font-size: 24px;
  font-weight: 600;
  color: ${props => props.theme.text};
  margin: 20px 0;
`

export const FormWrapper = styled.div`
  display: flex;
  gap: 10px;
  margin-bottom: 15px;
`

export const Info = styled.div`
  padding: 20px;
  background: ${props => props.theme.cardBackground};
  border-radius: 8px;
  margin-bottom: 15px;
`

export const InfoText = styled.div`
  font-size: 14px;
  color: ${props => props.theme.secondaryText};
  line-height: 1.5;
`

export const DarkForm = styled.div`
  background: ${props => props.theme.cardBackground};
  padding: 20px;
  border-radius: 8px;
`

